import $ from "jquery"
import "bootstrap/js/dist/collapse"
import "mark.js/dist/jquery.mark"

class Search {
	constructor() {
		// eslint-disable-next-line no-console
		console.log("Search::initialize()")

		this.$component = $(".bb-search")
		this.$searchForm = this.$component.find(".bb-search-input__form")
		this.$searchInput = this.$component.find(".bb-search-input__search-input")

		this._bindEvents()
	}

	_bindEvents() {
		$("body")
			.on("show.bs.collapse", ".bb-search", () => {
				this.$searchInput.val("")
				this.$searchForm.removeClass("bb-search-input__form--active")
			})
			.on("shown.bs.collapse", ".bb-search", () => {
				this.$searchInput.focus()
				$(document.body).addClass("search-overlay-open")
			})
			.on("hidden.bs.collapse", ".bb-search", () => {
				$(document.body).removeClass("search-overlay-open")
			})
			.on("click", ".bb-search__close", () => {
				$("#bb-search-overlay").collapse("hide")
			})
			.on("click", ".bb-search__show-all-results", (e) => {
				e.preventDefault()
				this.$searchForm.trigger("submit")
			})
	}
}

export default Search
